import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Spinner } from "@appsmith/ads";
import UserApi from "ee/api/UserApi";
import Container from "./Container";
import { getThemeDetails, ThemeMode } from "selectors/themeSelectors";
import type { AppState } from "ee/reducers";
import { ThemeProvider } from "styled-components";
import { useIsMobileDevice } from "utils/hooks/useDeviceDetect";

const LogoutContent = () => {
  const [status, setStatus] = useState<"loading" | "success">("loading");

  useEffect(() => {
    const performLogout = async () => {
      try {
        await UserApi.logoutUserGet();
        setStatus("success");
      } catch (error: any) {
        setStatus("success");
      }
    };

    performLogout();
  }, []);

  return (
    <Container title="Logout">
      {status === "loading" && (
        <div className="flex flex-col items-center gap-4 py-4">
          <Spinner size="lg" />
          <p className="text-[14px] text-center text-[color:var(--ads-v2-color-fg)]">
            Logging out...
          </p>
        </div>
      )}
      {status === "success" && (
        <div className="flex flex-col items-center gap-4 py-4">
          <div className="w-12 h-12 rounded-full bg-[color:var(--ads-v2-color-bg-success)] flex items-center justify-center">
            <svg
              className="w-6 h-6 text-[color:var(--ads-v2-color-fg-success)]"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M5 13l4 4L19 7"
              />
            </svg>
          </div>
          <p className="text-[14px] text-center text-[color:var(--ads-v2-color-fg)]">
            You have been successfully logged out. You can safely close this window.
          </p>
        </div>
      )}
    </Container>
  );
};

const Logout = () => {
  const lightTheme = useSelector((state: AppState) =>
    getThemeDetails(state, ThemeMode.LIGHT),
  );
  const isMobileDevice = useIsMobileDevice();

  return (
    <ThemeProvider theme={lightTheme}>
      <div
        className={`absolute inset-0 flex flex-col overflow-y-auto auth-container bg-[color:var(--ads-color-background-secondary)] ${
          !isMobileDevice ? "p-4" : "px-6 py-12"
        } t--auth-container justify-center`}
      >
        <LogoutContent />
      </div>
    </ThemeProvider>
  );
};

export default Logout;
